"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsAccessLocation = void 0;
var AnalyticsAccessLocation;
(function (AnalyticsAccessLocation) {
    AnalyticsAccessLocation["Onboarding"] = "Onboarding";
    AnalyticsAccessLocation["Hub"] = "Hub";
    AnalyticsAccessLocation["Library"] = "Library";
    AnalyticsAccessLocation["Settings"] = "Settings";
    AnalyticsAccessLocation["SettingsSharing"] = "SettingsSharing";
    AnalyticsAccessLocation["SettingsSharingGroupEditing"] = "SettingsSharingGroupEditing";
    AnalyticsAccessLocation["StoreMain"] = "StoreMain";
    AnalyticsAccessLocation["StoreStudent"] = "StoreStudent";
    AnalyticsAccessLocation["StoreProfessional"] = "StoreProfessional";
    AnalyticsAccessLocation["StoreInstitutional"] = "StoreInstitutional";
    AnalyticsAccessLocation["StoreInstitutionalAtlas"] = "StoreInstitutionalAtlas";
    AnalyticsAccessLocation["StoreInstitutionalCM"] = "StoreInstitutionalCM";
    AnalyticsAccessLocation["StoreInstitutionalVideos"] = "StoreInstitutionalVideos";
    AnalyticsAccessLocation["RadiologySequenceList"] = "RadiologySequenceList";
    AnalyticsAccessLocation["Infobox"] = "Infobox";
    AnalyticsAccessLocation["Lecture"] = "Lecture";
    AnalyticsAccessLocation["Search"] = "Search";
    AnalyticsAccessLocation["MainMenu"] = "MainMenu";
    AnalyticsAccessLocation["ModelsMenu"] = "ModelsMenu";
    AnalyticsAccessLocation["ShortcutTip"] = "ShortcutTip";
    AnalyticsAccessLocation["Recents"] = "Recents";
    AnalyticsAccessLocation["CurriculumManager"] = "CurriculumManager";
    AnalyticsAccessLocation["Tips"] = "Tips";
    AnalyticsAccessLocation["AccessPopup"] = "AccessPopup";
    AnalyticsAccessLocation["LightboxPage"] = "LightboxPage";
    AnalyticsAccessLocation["Other"] = "Other";
})(AnalyticsAccessLocation || (exports.AnalyticsAccessLocation = AnalyticsAccessLocation = {}));
